import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ProjectManagementPage from "@/pages/admin/ProjectManagementPage";

export const Route = createFileRoute("/_admin/admin/projects")({
  head: () => pageHead("Admin · Projects", "AKIVA admin · projects portal.", "/admin/projects", true),
  component: ProjectManagementPage,
});
